import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  content: {
    title: '',
    message: '',
    action: null,
    route: null
  }
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.RECEIVE_ALERT: {
      const newState = state.setIn(['content'], action.payload)

      return newState
    }

    case types.RESET_ALERT: {
      const newState = state.setIn(['content'], INITIAL_STATE.content)

      return newState
    }

    default: {
      return state
    }
  }
}

export default reducer
